/**
 * Strings every poetry-analysis widget shares: why a word can be read more than one way.
 *
 * Each widget spreads these into its own `<SLUG>_STRINGS` object, so a translated content
 * file overrides them like any other widget string.
 */
export const POETRY_READING_STRINGS = {
  reasonDiphthongEr:
    "Can be said as one syllable (fire, hour, flower), as many poets do.",
  reasonSyncope:
    "Verse often drops a syllable here (every as ev'ry, heaven as heav'n, wandering as wand'ring).",
  reasonFullForm:
    "The dictionary shortens this word; verse often sounds it in full (tem-per-ate).",
  reasonEdEnding:
    "Older verse sounds the -ed as its own syllable (blessèd, learnèd).",
  reasonIonEnding:
    "Classical verse sometimes sounds -ion as two syllables (na-ti-on).",
  reasonEstimate:
    "Not in the dictionary, so this count is a guess from the spelling. Adjust it if it is wrong.",
  sourceEstimated:
    "Not in the pronunciation dictionary — syllables estimated from spelling, stress unknown.",
  sourcePoetic: "Poetic spelling, read as it would be spoken.",
  sourceElided: "Elided spelling: the apostrophe stands for a dropped vowel.",
  dictionaryLoading: "Loading the pronunciation dictionary…",
  dictionaryFailed:
    "The pronunciation dictionary could not be loaded, so every word is estimated from its spelling. Reload the page to try again.",
  numbersSkipped:
    "Digits are not counted — write numbers out as words to include them.",
} as const;

export type ReadingReasonKey =
  | "reasonDiphthongEr"
  | "reasonSyncope"
  | "reasonFullForm"
  | "reasonEdEnding"
  | "reasonIonEnding"
  | "reasonEstimate";

/** Reason code → the key of its sentence in `POETRY_READING_STRINGS`. */
export const REASON_KEYS = {
  "diphthong-er": "reasonDiphthongEr",
  syncope: "reasonSyncope",
  "full-form": "reasonFullForm",
  "ed-ending": "reasonEdEnding",
  "ion-ending": "reasonIonEnding",
  estimate: "reasonEstimate",
  elision: "reasonSyncope",
} as const satisfies Record<string, ReadingReasonKey>;
